/*!

=========================================================
* Argon Dashboard PRO React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// react library for routing
import { useLocation, Route, Redirect } from "react-router-dom";
// core components
import AdminNavbar from "../components/Navbars/AdminNavbar.js";
import AdminFooter from "../components/Footers/AdminFooter.js";
import Sidebar from "../components/Sidebar/Sidebar.js";
import routes from "../routes.js";
import { getUserPermission } from "../utils/getUserPermission.js";

function Admin() {
  const [sidenavOpen, setSidenavOpen] = React.useState(true);
  const location = useLocation();
  const mainContentRef = React.useRef(null);
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContentRef.current.scrollTop = 0;
    setSidenavOpen(true);
  }, [location]);
  React.useEffect(() => {
    document.body.classList.add("g-sidenav-pinned");
    document.body.classList.remove("g-sidenav-hidden");
  }, []);
  const getRoutes = (routes) => {
    let routeLinks = routes.map((prop, key) => {
    
      if (prop.collapse) {
        return getRoutes(prop.views);
      }

      if(prop.path ==="/"){
      
        return (<Route exact path="/">
                <Redirect to="/dashboard" />
            </Route>) ;
      }
      return <Route path={prop.path} component={prop.component} key={key} />;

    });
    return routeLinks;
  };
  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (location.pathname.indexOf(routes[i].layout + routes[i].path) !== -1) {
        return routes[i].name;
      }
    }
    return "Brand";
  };
  // toggles collapse between mini sidenav and normal
  const toggleSidenav = (e) => {
    if (document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-pinned");
      document.body.classList.add("g-sidenav-hidden");
    } else {
      document.body.classList.add("g-sidenav-pinned");
      document.body.classList.remove("g-sidenav-hidden");
    }
    setSidenavOpen(!sidenavOpen);
  };
  const getNavbarTheme = () => {
    return location.pathname.indexOf("admin/alternative-dashboard") === -1
      ? "dark"
      : "light";
  };

  return (
    <>
      <Sidebar
        routes={routes}
        toggleSidenav={toggleSidenav}
        sidenavOpen={sidenavOpen}
        logo={{
          innerLink: "/dashboard",
          imgSrc: require("../assets/img/brand/farocg.png").default,
          imgAlt: "...",
        }}
      />
      <div className='main-content' ref={mainContentRef}>
        <AdminNavbar
          theme={getNavbarTheme()}
          toggleSidenav={toggleSidenav}
          sidenavOpen={sidenavOpen}
          brandText={getBrandText(location.pathname)}
        />
        <div style={{ minHeight: "85vh", width: "90%", margin: "0 auto" }}>
          {getRoutes(routes)}
          <Route exact path="/">
                <Redirect to="/dashboard" />
            </Route>

        
        </div>
        <AdminFooter />
      </div>
      {sidenavOpen ? (
        <div className='backdrop d-xl-none' onClick={toggleSidenav} />
      ) : null}
    </>
  );
}

export default Admin;
